export enum ExpectedStatementPaymentTypes {
    AnACC = 'AnACC',
    FacilityTotalApprovedBedsPayment = 'Facility total approved beds payment'
}